import type { TransmissionNoticeData } from '../databus/DataSyncManager'
import type { FileInfo } from './IReadOnlyFileTransmissionManager'

export enum TaskError {
  DEVICE_NOT_FOUND = 'device_not_found',
  CREATE_NOTICE_FAILED = 'create_notice_failed',
  NATIVE_SERVICE_BIND_FAILED = 'native_service_bind_failed',
  NOTIFICATION_DEVICE_FAILED = 'notification_device_failed',
  TRANSFER_FAILED = 'transfer_failed',
  COMMON = 'common',
  TASK_STATE_SYNC_TIMEOUT = 'task_state_sync_timeout',
  DEVICE_CANCEL = 'device_cancel',
  SERVER_REMOTE_CANCEL = 'server_remote_cancel',
  DEVICE_NOTIFIED_FAILURE_MESSAGE = 'device_notified_failure_message',
  GET_DEVICE_DOWNLOAD_URL_FAILED = 'get_device_download_url_failed',
}

export enum DeviceTaskError {
  DEVICE_HAVE_NOT_ENOUGH_SPACE_AVAILABLE = '20001',
  FILE_SIZE_EXCEEDS_THE_LIMIT = '20002',
  FILE_COMPRESSION_FAILURE = '20003',
  COMMON = '20000',
  DEVICE_CANCEL = '20099',
}

export const TaskErrorTipsMap = new Map<TaskError | DeviceTaskError, string>([
  [TaskError.DEVICE_NOT_FOUND, '设备未找到'],
  [TaskError.CREATE_NOTICE_FAILED, '创建传输消息失败'],
  [TaskError.NATIVE_SERVICE_BIND_FAILED, '绑定文件管理服务失败'],
  [TaskError.NOTIFICATION_DEVICE_FAILED, '通知设备失败'],
  [TaskError.TRANSFER_FAILED, '文件传输失败'],
  [TaskError.COMMON, '未知错误'],
  [TaskError.TASK_STATE_SYNC_TIMEOUT, '任务状态同步超时'],
  [TaskError.DEVICE_CANCEL, '设备取消'],
  [TaskError.SERVER_REMOTE_CANCEL, '服务器远程取消'],
  [TaskError.DEVICE_NOTIFIED_FAILURE_MESSAGE, '设备通知失败消息'],
  [TaskError.GET_DEVICE_DOWNLOAD_URL_FAILED, '获取设备下载链接失败'],
  [
    DeviceTaskError.DEVICE_HAVE_NOT_ENOUGH_SPACE_AVAILABLE,
    'owork_base.transmission.task_failed_reason_not_enough_space',
  ],
  [DeviceTaskError.FILE_SIZE_EXCEEDS_THE_LIMIT, 'owork_base.transmission.task_failed_reason_file_size_limit'],
  [DeviceTaskError.FILE_COMPRESSION_FAILURE, 'owork_base.transmission.task_failed_reason_file_compress_failed'],
  [DeviceTaskError.COMMON, 'owork_base.transmission.task_failed_reason_common'],
  [DeviceTaskError.DEVICE_CANCEL, 'owork_base.transmission.task_failed_reason_device_cancel'],
])

export enum FailedReason {
  DEVICE_CANCEL = 'cancel',
}

//任务当前状态
export enum TaskState {
  IDLE, //新建
  GOING, //执行中
  WAITING, //等待执行
  PAUSE, //暂停中
  SUCCESS, //成功
  FAILED, //失败
}

export interface ITask {
  id: string
  sequenceId: number
  start(): Promise<void>
  pause(): Promise<void>
  resume(): Promise<void>
  onRemove(needCallService?: boolean): Promise<boolean>
  updateInfo(transmissionNotice: TransmissionNoticeData, isFreezed?: boolean): void
}

export interface TaskInfo {
  id: string
  appId: string
  fileName: string
  fileSize: number
  state: TaskState
  sourceDeviceId: string
  completionRatio: number
  isViaLan: boolean
  canChangeState: boolean
  failedReason?: TaskError | DeviceTaskError
  transmissionTaskType: TransmissionTaskType
  //下面三个属性 下载信息使用
  downloadUrl?: string
  deviceName?: string
  path?: string
  relativePath?: string
  targetPath?: string
  deviceId?: string
  objectUrl?: string
  failedReasonTips?: string
}

export enum TransmissionTaskType {
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  ZIP = 'zip',
}

export interface GroupFileInfo {
  fileName: string // `${tabName}_${timestamp}`
  files: GroupFiles[] // 主要透传文管微应用参数
}

export interface GroupFiles {
  fileName: string
  fileType: string
  filePath: string
}

export interface BaseTaskInfo {
  appId: string
  deviceId: string
  fileInfos: FileInfo[]
  isViaCloud?: boolean
}

export interface SpecificTaskInfo {
  sourceTaskType: TransmissionTaskType
  id: string
  sequenceId: number
}

export interface MirrorTaskInfo extends SpecificTaskInfo, BaseTaskInfo {}
